import { createAction } from '@reduxjs/toolkit';

import { Direction, RangeType } from '../../enums';
import { IError, IPatient, IPhysiologicalData } from '../../interfaces';

export const resetPhysiologicalData = createAction('physiological-data.reset-physiological-data');
export const changeRangeType = createAction<{ rangeType: RangeType }>('physiological-data.change-range-type');
export const changeDateRange = createAction<{ direction: Direction }>('physiological-data.change-date-range');
export const resetToDefaultViewAndRange = createAction('physiological-data.reset-to-default-view-and-range');

export const fetchPhysiologicalData = createAction<{
  rangeType: RangeType;
  dateFrom: string;
  dateTo: string;
  patient: IPatient;
}>('physiological-data.fetch-physiological-data');
export const fetchPhysiologicalDataSucceeded = createAction<{
  physiologicalData: IPhysiologicalData;
  patient: IPatient;
  rangeType: RangeType;
}>('physiological-data.fetch-physiological-data.succeeded');
export const fetchPhysiologicalDataFailed = createAction<IError>('physiological-data.fetch-physiological-data.failed');

export const fetchCuffMeasurements = createAction<{
  dateFrom: string;
  dateTo: string;
  patientId: number;
}>('physiological-data.fetch-cuff-measurements');
export const fetchCuffMeasurementsSucceeded = createAction<{ physiologicalData: IPhysiologicalData }>(
  'physiological-data.fetch-cuff-measurements.succeeded',
);
export const fetchCuffMeasurementsFailed = createAction<IError>('physiological-data.fetch-cuff-measurements.failed');
